module.exports = __webpack_public_path__ + "img/purchase-icon.617e6ea1.svg";